import { validateTargetedOfferToApply } from './validateTargetedOfferToApply';
import { COUPON } from 'contexts/CruiseSearchContext/constants';

export const validateTargetedOffersAvailable = ({
  updateState,
  query,
  newTargetedOfferState,
  enableDisabledPromotionMessage,
  removeFromQualifiersSelecting,
  applyFilters,
}) => {
  const { isInvalidPromo, qualifiers, promoCodeApplied, disabledPromoMessage } =
    validateTargetedOfferToApply({
      query,
      newTargetedOfferState,
      enableDisabledPromotionMessage,
    });

  if (isInvalidPromo) {
    removeFromQualifiersSelecting(
      `${COUPON}:${qualifiers[COUPON]?.split(',')?.[0]}`,
      applyFilters,
    );
  }

  updateState({
    targetedOfferApplied: isInvalidPromo ? {} : promoCodeApplied,
    targetedOfferSelected: isInvalidPromo ? {} : promoCodeApplied,
    targetedOfferIsValidPromo: !isInvalidPromo,
    targetedOffersDisabledMessage: disabledPromoMessage,
    targetedofferUrlValidateMatch: true,
  });
};
